<template>
<div>
    <div class="label">
        {{label}}
    </div>

    <div 
        class="chip_row"
        style="min-height: 50px"
    >

        <div class="chip_container">
            <v-chip
                v-for="(item, index) in selected_items"
                style="margin-right: 5px; margin-bottom: 5px;"
                :key="index"
                :close="!read_only"
                v-on:click:close="onClickClose(item)"
            >
                {{item.text}}
            </v-chip>

            <v-chip
                v-if="value.length == 0"
                style="margin-right: 5px; margin-bottom: 5px; color: rgba(0,0,0,0.25)"
            >
                {{no_item_text}}
            </v-chip>
        </div>

         <v-icon
            v-if="!read_only"
            v-on:click="onClickEdit"
            color="primary"
         >
            mdi-lead-pencil
         </v-icon>

    </div>

    <m-edit-multi-select-dialog
        ref="dialog"
        v-on:ok="onDialogOk"
    />
    
</div>
</template>

<script>
const _ = require('lodash');
export default {
    props: {
        value: {
            type: Array,
            default: function() { return []; }
        },

        label: {
            type: String,
            default: function() { return 'label'; }
        },

        items: {
            type: Array,
            default: function() { return []; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        no_item_text: {
            type: String,
            default: function() { return "None Selected"; }
        },
    },

    methods: {
        onClickClose(remove_item) {
            let new_value = _.cloneDeep(this.value);
            new_value = new_value.filter(value => value != remove_item.value);
            this.$emit('input', new_value);
        },

        onClickEdit()
        {
            this.$refs['dialog'].showDialog(this.$props);
        },

        onDialogOk(new_value)
        {
            this.$emit('input', new_value);
        },
    },

    computed: {
        selected_items() {
            return this.items.filter(item => this.value.includes(item.value));
        }
    },
}
</script>

<style lang="scss" scoped>
.label
{
    color: rgba(0,0,0,0.38);
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 400;
}

.chip_row
{
    display: flex;
}

.chip_container
{
    flex-grow: 1;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    padding-bottom: 5px;
    padding-top: 5px;
}

.edit_container
{
    flex-grow: 0;
}
</style>